import type { HqPermission, MeResponse } from "@bube-hq/contracts";
import { create } from "zustand";

import { onUnauthenticated } from "../shared/api/http.js";

/**
 * Phiên hiện tại của dashboard.
 *
 * ── Quyền ở đây CHỈ để ẩn/hiện, không phải để bảo vệ ────────────────────────
 *
 * Máy chủ mới là nơi ép quyền (`PermissionGuard`). Ẩn một nút không ngăn ai gọi API bằng `curl` —
 * và một hệ thống mà giao diện là hàng rào duy nhất thì hàng rào đó nằm trong máy của người dùng.
 */
type SessionState = {
  session: MeResponse | null;
  status: "dang-tai" | "co-phien" | "chua-dang-nhap";
  setSession: (s: MeResponse) => void;
  clear: () => void;
  can: (permission: HqPermission) => boolean;
};

export const useSession = create<SessionState>((set, get) => ({
  session: null,
  status: "dang-tai",
  setSession: (session) => set({ session, status: "co-phien" }),
  clear: () => set({ session: null, status: "chua-dang-nhap" }),
  can: (permission) => get().session?.permissions.includes(permission) ?? false,
}));

// Phiên chết giữa chừng (bất kỳ request nào trả `HQ_UNAUTHENTICATED`) ⇒ xoá phiên; `SessionGate` đưa
// người dùng về màn đăng nhập. Chỉ xoá khi đang CÓ phiên — lượt `/me` đầu tiên do `SessionGate` tự xử.
onUnauthenticated(() => {
  if (useSession.getState().status === "co-phien") useSession.getState().clear();
});
